import * as React from 'react';

const testValidity = (value, rule = /.*/) => {
  if (typeof rule === 'function') {
    return Boolean(rule(value || ''));
  } else {
    return Boolean((value || '').match(rule));
  }
};

const formFieldReducer = (
  state = { value: null, shouldShowValidationError: false },
  action,
) => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        value: action.value,
        rule: action.rule,
        isValid: testValidity(action.value, action.rule),
        shouldShowValidationError: false,
      };
    case 'SET_VALUE':
      return {
        ...state,
        value: action.value,
        isValid: testValidity(action.value, state.rule),
        shouldShowValidationError: false,
      };
    case 'SHOW_ALL_VALIDATION_ERRORS':
      return {
        ...state,
        shouldShowValidationError: !state.isValid,
      };
    default:
      return state;
  }
};

const initFormFieldState = (fields) => {
  return formReducer({}, { type: 'INIT', fields });
};

const formReducer = (state = {}, action) => {
  switch (action.type) {
    case 'INIT':
      const newFields = Object.keys(action.fields).reduce((accum, fieldId) => {
        const field = action.fields[fieldId];

        accum[fieldId] = formFieldReducer(
          {},
          {
            type: 'INIT',
            value: field.value,
            rule: field.rule,
          },
        );

        return accum;
      }, {});

      return { ...state, ...newFields };
    case 'SHOW_ALL_VALIDATION_ERRORS':
      const newState = Object.keys(state).reduce((accum, fieldId) => {
        const field = state[fieldId];

        accum[fieldId] = formFieldReducer(field, action);

        return accum;
      }, {});

      return newState;
    case 'REMOVE_FIELD':
      const { [action.fieldId]: field, ...rest } = state;

      return rest;
    default:
      return {
        ...state,
        [action.fieldId]: formFieldReducer(state[action.fieldId], action),
      };
  }
};

export const areAllFieldsValid = (state) => {
  return Object.keys(state).every((fieldId) => {
    return state[fieldId].isValid;
  });
};

export const useFormState = (initialState) => {
  const [formState, dispatch] = React.useReducer(
    formReducer,
    initialState,
    initFormFieldState,
  );

  const actions = {
    addField: (fields) => {
      dispatch({
        type: 'INIT',
        fields,
      });
    },
    showAllValidationErrors: () => {
      dispatch({ type: 'SHOW_ALL_VALIDATION_ERRORS' });
    },
    setValue: (fieldId, value) => {
      dispatch({
        type: 'SET_VALUE',
        fieldId,
        value,
      });
    },
    removeField: (fieldId) => {
      dispatch({ type: 'REMOVE_FIELD', fieldId });
    },
  };

  return [formState, actions];
};
